const manomano = (typeof window !== 'undefined' && window.manomano) || {};
const body =
    (typeof document !== 'undefined' && document.querySelector('body')) || {};

export const getBaseUrls = () => manomano.base_urls;
export const getListingData = () => {
    const listingData = { ...manomano.listingData };

    if (listingData.type === 'category' && listingData.category) {
        listingData.params = { ...listingData.category };
        delete listingData.category;
    }

    if (listingData.type === 'brand' && listingData.brand) {
        listingData.params = { ...listingData.brand };
        delete listingData.brand;
    }

    return listingData;
};
export const getMasslandingData = () => manomano.masslanding_links;
export const getPlatform = () => manomano.platform;
export const isSalePeriod = () => manomano.is_sales_period;
export const getSlider = () => manomano.slider || { createSlider: () => {} };
export const getSmartSticky = () => manomano.SmartSticky;
export const getUser = () => manomano.user;
export const getWishlist = () => manomano.wishlist;
export const getFamilies = () => manomano.color_families;
export const getLocation = () =>
    typeof window !== 'undefined' && window.location;
export const clickAddToBasketAction = () => manomano.clickAddToBasketAction;
export const getMobileMenu = () => manomano.menu;
export const getDataLayer = () =>
    typeof window !== 'undefined' && window.dataLayer;
export const getAlgoliaAppInfo = () => manomano.algolia;
export const getLocalStorage = () =>
    typeof window !== 'undefined' && window.localStorage;
export const getScroll = () => ({
    scrollY:
        typeof window !== 'undefined' && window.scrollY ? window.scrollY : 0,
});
export const getListingTooltip = () => manomano.listingTooltip;
export const cleanCategoryHeader = () => manomano.cleanCategoryHeader;
export const getOffsetWidth = () =>
    typeof document !== 'undefined' && document.offsetWidth;
export const getEnvironment = () =>
    typeof body !== 'undefined' &&
    typeof body.dataset !== 'undefined' &&
    body.dataset.environment;
export const getFeatureFlagsData = () => manomano.featureFlags_abTests;
export const getTranscriber = () => manomano.transcriber;
export const isNewUser = () =>
    manomano.isNewUser && typeof manomano.isNewUser === 'function'
        ? manomano.isNewUser()
        : false;
